import { Injectable } from '@angular/core';
import { forkJoin, Observable, Subject } from 'rxjs';
import { PersonSearchService } from '../_services/person-search.service';
import { FreemiumFilter, FreemiumJdData, FreemiumParams, PersonData } from './freemiumParams';
import * as _ from 'underscore';
import { AggregationRequest } from '../common-interfaces-classes/AggregationRequest';
import { PersonInsightsData } from '../hire-person-search/hire-insights/PersonInsightsData';
import { FusionChartsService } from '../_services/fusion-charts.service';
import { FreemiumJobDescriptionKeys, mandatoryFreemiumJDKeys } from './freemiumJobDescriptionkeys';
import { FreemiumAPIService } from './freemium-api.service';
import { LoaderType } from './freemiumConstants';


@Injectable({
  providedIn: 'root'
})
export class FreemiumService {

  constructor(private personSearchService: PersonSearchService, private fusionChartService: FusionChartsService, private freemiumApiService: FreemiumAPIService) { }
  private freemiumParams: FreemiumParams;
  private showInsightsEvent: Subject<any> = new Subject();
  private insightsFreemiumDataSubject: Subject<any> = new Subject();
  private freemiumJDDataEvent: Subject<FreemiumJdData> = new Subject();
  private freemiumFilters: FreemiumFilter;
  private freemiumModalData: mandatoryFreemiumJDKeys;
  private showInsightsAfterLoader: Subject<any> = new Subject();

  private VALID_CONTINENTS = [
    "asia", "africa", "north america", "oceania", "south america"
  ];


  get fetchQuickSearchData(): FreemiumParams {
    return Object.assign({}, this.freemiumParams);
  }

  setQuickSearchData(filterData: FreemiumParams) {
    this.freemiumParams = Object.assign({}, filterData);

  }

  get getInsightsProfileSection(): Observable<any> {
    return this.showInsightsEvent.asObservable();
  }

  changensightsProfileSection(statsObject) {
    this.showInsightsEvent.next(statsObject);
  }

  get insightsFreemiumDataEvent(): Observable<any> {
    return this.insightsFreemiumDataSubject.asObservable();
  }

  emitInsightsFreemiumObject(insightsData: any) {
    this.insightsFreemiumDataSubject.next(insightsData);
  }


  getfreemiumAggs() {
    // if (!statusMap || _.isEmpty(statusMap)) {
    //   statusMap = this.getStatusMap(this.filterDataHandlerService.fetchFilterData);
    // }
    const aggObservations: Observable<any>[] = [
      this.getAggregationReport('location'),
      this.getAggregationReport('skills'),
      this.getAggregationReport('jobtitle'),
      this.getAggregationReport('company'),
      this.getAggregationReport('industry'),
      this.getAggregationReport('totalyearsofexperience')
    ];
    // if (statusMap.jobTitleStatus === CallStage.CURRENT_OR_PAST.toString()) aggObservations.push(this.getAggregationReport('jobtitle'));
    // if (statusMap.jobTitleStatus === CallStage.CURRENT.toString()) aggObservations.push(this.getAggregationReport('current_jobtitle'));
    // if (statusMap.jobTitleStatus === CallStage.PAST.toString()) aggObservations.push(this.getAggregationReport('pastjobtitle'));

    // if (statusMap.companyStatus === CallStage.CURRENT_OR_PAST.toString())  aggObservations.push(this.getAggregationReport('company'));
    // if (statusMap.companyStatus === CallStage.CURRENT.toString())  aggObservations.push(this.getAggregationReport('current_company'));
    // if (statusMap.companyStatus === CallStage.PAST.toString())  aggObservations.push(this.getAggregationReport('pastcompany'));

    // if (statusMap.industryStatus === CallStage.CURRENT_OR_PAST.toString()) aggObservations.push(this.getAggregationReport('industry'));
    // if (statusMap.industryStatus === CallStage.CURRENT.toString()) aggObservations.push(this.getAggregationReport('current_industry'));
    // if (statusMap.industryStatus === CallStage.PAST.toString()) aggObservations.push(this.getAggregationReport('pastindustry'));



    // this.loaderEventService.emitLoaderObject(LoaderType.INSIGHTS);
    aggObservations.forEach(obs => obs.subscribe(res => this.emitInsightsFreemiumObject(res)));



  }

  private getAggregationReport(aggregatetype: string, obj?: any) {
    // const localRequestObject = this.aggReqObjHandler.getSharedRequestObject();
    const localRequestObject = this.getRequestWithFilters();
    Object.assign(localRequestObject, {
      resultsize: 1,
      aggregatetype: aggregatetype
    });
    if ((aggregatetype === "changedjobs") && obj && !_.isEmpty(obj)) {
      Object.assign(localRequestObject, {
        // changedjobsstartdurationinmonths: obj?.statrDuration,
        changedjobsenddurationinmonths: obj?.endDuration,
      });
    }
    if ((aggregatetype === "changedjobs")) {
      Object.assign(localRequestObject, {
        // changedjobsstartdurationinmonths: obj?.statrDuration,
        changedjobs: 'yes'
      });
    }
    delete localRequestObject["talentdiscoveryhistoryid"];



    return this.freemiumApiService.getFreemiumTotalAggs(localRequestObject);
  }


  getRequestWithFilters() {
    let filterData = this.fetchQuickSearchData;
    //  this.freemiumJdDataEventObs.subscribe(res=>)
    // const request = {
    //   startindex: 0,
    //   resultsize: "25",
    //   searchviaboolean: true,
    //   booleanquery: "*",
    //   jobtitles: _.pluck(filterData.jobTitleSelectedList, 'key'),
    //   pastjobtitles: [],
    //   exclude_pastjobtitles: [],
    //   preferredskills: _.pluck(filterData.skillsSelectedList, 'key'),
    //   mandatoryskills: [],
    //   locations: _.pluck(filterData.locationSelectedList, 'key'),
    //   companies: _.pluck(filterData.companySelectedList, 'key'),
    //   industries: [],
    //   exclusionlist: [],
    //   genders: [
    //     "All"
    //   ],
    //   seniority: [],
    //   graduationyear: [],
    //   schools: [],
    //   schooltypes: [],
    //   educationaldegrees: [],
    //   educationalmajors: [],
    //   candidateshavingemails: false,
    //   candidateshavingcontactnumbers: false,
    //   minexperience: null,
    //   maxexperience: null,
    //   minexperienceinccurrentcompany: null,
    //   zipcodes: [],
    //   companysizes: [],
    //   candidateshavingcontacts: false,
    //   exclude_jobtitles: [],
    //   exclude_companies: [],
    //   exclude_locations: [],
    //   companytype: "Current",
    //   jobtitletype: "Current",
    //   industrytype: "Current",
    //   fromyearsofexperience: [],
    //   toyearsofexperience: [],
    //   experiencetype: "Total",
    //   likelytomovetype: null,
    //   linkedinurl: null,
    //   isUploadedFromResume: false,
    //   fullname: "",
    //   similarcandidates_industries: null,
    //   similarcandidates_locations: null,
    //   similarcandidates_companysizes: null,
    //   similarcandidates_fromyearsofexperience: null,
    //   similarcandidates_toyearsofexperience: null,
    //   similarcandidates_jobtitles: null,
    //   exclude_persons: null,
    //   continentstobeincluded: filterData.continentstobeincluded,
    //   functions: [],
    //   fullnames: [],
    //   changedjobsstartdurationinmonths: 0,
    //   changedjobsenddurationinmonths: 12,
    //   changedjobs: null,
    //   distancefromselectedlocationsmeasurementunit: null,
    //   distancefromselectedlocations: null,
    //   currentfromyearsofexperience: [],
    //   currenttoyearsofexperience: [],
    //   searchedfrom: "",
    //   exclude_industries: [],
    //   schoollocation: [],
    //   exclude_schoollocation: [],
    //   needcuratedtalentpooltags: true,
    //   profilehighlights: [],
    //   job_description_keys: filterData.job_description_keys

    // }

    const request = {
      searchviaboolean: true,
      booleanquery: "*",
      jobtitles: _.pluck(filterData.jobTitleSelectedList, 'key'),
      mandatoryskills: [],
      locations: _.pluck(filterData.locationSelectedList, 'key'),
      continentstobeincluded: filterData.continentstobeincluded,
      companies: _.pluck(filterData.companySelectedList, 'key'),
      companyids: [],
      industries: [],
      exclusionlist: [],
      genders: [
        "All"
      ],
      seniority: [],
      graduationyear: [],
      schools: [],
      schooltypes: [],
      educationaldegrees: [],
      educationalmajors: [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: [],
      companysizes: [],
      candidateshavingcontacts: false,
      workregions: [],
      workcountries: [],
      worklocalities: [],
      spokenlanguages: [],
      contacts: [
        "All"
      ],
      candidateshavingmobilenumber: false,
      candidateshavingpersonalemail: false,
      candidateshavingprofessionalemail: false,
      candidateshavingsocialprofiles: false,
      fromgraduationyears: [],
      tograduationyears: [],
      exclude_jobtitles: [],
      exclude_companies: [],
      exclude_locations: [],
      companytype: "Current",
      jobtitletype: "Current",
      industrytype: "Current",
      fromyearsofexperience: [],
      toyearsofexperience: [],
      experiencetype: "Total",
      likelytomovetype: "All",
      salaries: [
        "All"
      ],
      salaryranges: [
        "All"
      ],
      functions: [],
      distancefromselectedlocationsmeasurementunit: "kilometers",
      distancefromselectedlocations: 20,
      startindex: 0,
      resultsize: "25",
      pastjobtitles: [],
      exclude_pastjobtitles: [],
      preferredskills: _.pluck(filterData.skillsSelectedList, 'key'),
      profilehighlights: [],
      exclude_industries: [],
      functiontype: "All",
      currentfromyearsofexperience: [],
      currenttoyearsofexperience: [],
      schoollocation: [],
      exclude_schoollocation: [],
      changedjobs: "all",
      changedjobsstartdurationinmonths: 0,
      changedjobsenddurationinmonths: 12,
      fullnames: [],
      talentdiscoveryhistoryid: null,
      mandatoryjobtitles: [],
      mandatorylocations: false,
      mandatorycompanies: false,
      mandatoryindustries: false,
      mandatoryschools: false,
      mandatoryfunctions: [],
      mandatoryeducationalmajors: false,
      mandatoryeducationaldegrees: false,
      mandatoryseniority: [],
      insightslocations: [],
      insightscompanies: [],
      insightsindustries: [],
      insightsschools: [],
      insightseducationalmajors: [],
      insightsjobtitles: [],
      insightspastjobtitles: [],
      insightspreferredskills: [],
      insightsfunctions: [],
      insightseducationaldegrees: [],
      insightsseniority: [],
      lastjobcompanies: [],
      needcuratedtalentpooltags: true,
      job_description_keys: filterData.job_description_keys
    }

    return request;
  }

  getpersonSearchRecommend() {
    this.getfreemiumAggs()
  }

  processFreemiumTalentInsights(
    pIData: PersonInsightsData,
    resp: any,
    reqObj: AggregationRequest
  ) {
    const response = Object.assign({}, resp);
    const personInsightsData = Object.assign({}, pIData);
    const localReqObj = Object.assign({}, reqObj);
    if (
      localReqObj.aggregatetype === "totalyearsofexperience" ||
      localReqObj.aggregatetype === "averageyearsofexperience"
    ) {
      personInsightsData.dataSourceCurrentExperience =
        this.createCurrentExperience(response, localReqObj.aggregatetype);
    } else if (localReqObj.aggregatetype === "location") {
      personInsightsData.topLocations = response?.location;
      personInsightsData.dataSourceWorkCountry =
        this.createWorkCountryData(response);
    } else if (
      localReqObj.aggregatetype === "current_company" ||
      localReqObj.aggregatetype === "company" ||
      localReqObj.aggregatetype === "pastcompany"
    ) {
      personInsightsData.dataSourceCurrentCompany = this.createCompanyData(
        !!response[localReqObj.aggregatetype]
          ? response[localReqObj.aggregatetype].slice(0, 5)
          : []
      );
    } else if (
      localReqObj.aggregatetype === "jobtitle" ||
      localReqObj.aggregatetype === "current_jobtitle" ||
      localReqObj.aggregatetype === "pastjobtitle"
    ) {
      personInsightsData.titles = response[localReqObj.aggregatetype]?.slice(0, 5);
    } else if (localReqObj.aggregatetype === "school") {
      personInsightsData.school =
        response[localReqObj.aggregatetype]?.slice(0, 5) || [];
    } else if (localReqObj.aggregatetype === "skills") {
      personInsightsData.skills =
        response[localReqObj.aggregatetype]?.slice(0, 5) || [];
    } else if (localReqObj.aggregatetype === "fieldofstudy") {
      personInsightsData.fieldOfStudy =
        response[localReqObj.aggregatetype]?.slice(0, 5) || [];
    } else if (
      localReqObj.aggregatetype === "current_industry" ||
      localReqObj.aggregatetype === "industry" ||
      localReqObj.aggregatetype === "pastindustry"
    ) {
      personInsightsData.currentIndustry =
        response[localReqObj.aggregatetype]?.slice(0, 5) || [];
    }
    return personInsightsData;
  }

  private createCurrentExperience(response, type) {
    const dataSourceCurrentExperience = this.fusionChartService.yearsOfExperience(response[type], 'personSearchInsights')
    return dataSourceCurrentExperience;
  }

  createWorkCountryData(response) {
    const CharForworkCountry = [];
    CharForworkCountry.push(["Location", "Talent count"]);
    response?.location.slice(0, 10).forEach((x) => {
      const dataObj = [
        `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`,
        x.doc_count,
      ];
      CharForworkCountry.push(dataObj);
    });
    return CharForworkCountry;
  }


  private createCompanyData(companies: any[]) {
    const CharForCurrentCompany = [];
    companies.forEach((x) => {
      let dataObj = {
        label: `${x.key.charAt(0).toUpperCase()}${x.key.slice(1)}`,
        value: x.doc_count,
        tooltext: `${x.key.charAt(0).toUpperCase()}${x.key.slice(
          1
        )} <br> Talent count: ${x.doc_count}`,
        companylogo: x.companylogo,
        name: x.name,
        industry: x.industry,
        location: x.location,
        size: x.size,
        website: x.website,
        linkedin_url: x.linkedin_url,
        tags: x.tags,
      };
      CharForCurrentCompany.push(dataObj);
    });

    const dataSourceCurrentCompany = {
      type: "column2d",
      dataFormat: "json",
      height: 14,
      width: 14,
      chart: {
        renderAt: "chart-container",
        paletteColors: "#5c63a2",
        showPercentValues: "1",
        yAxisNameFontColor: "#2C2C2C",
        legendPosition: "right",
        theme: "fusion",
        showValues: "1",
        labelFont: "Poppins",
        legendItemFont: "Poppins",
        legendItemFontSize: "12",
      },
      data: CharForCurrentCompany,
    };
    return dataSourceCurrentCompany;
  }

  get freemiumJdDataEventObs(): Observable<FreemiumJdData> {
    return this.freemiumJDDataEvent.asObservable();
  }

  emitFreemiumJDDataEvent(data: FreemiumJdData) {
    this.freemiumJDDataEvent.next(data);
  }

  getFreemiumJdKeys(jdDetails: mandatoryFreemiumJDKeys) {
    const jdKeys = new FreemiumJobDescriptionKeys();

    jdDetails.jobtitle && jdDetails.jobtitle.forEach(jt => {
      if (jt.isMandatory && Array.isArray(jdKeys.mandatory_job_titles)) jdKeys.mandatory_job_titles.push(jt.key);
      else if (Array.isArray(jdKeys.job_titles)) jdKeys.job_titles.push(jt.key);
    })

    jdDetails.company.forEach(jt => {
      if (jt.isMandatory && Array.isArray(jdKeys.mandatory_companies)) jdKeys.mandatory_companies.push(jt.key);
      else if (Array.isArray(jdKeys.companies)) jdKeys.companies.push(jt.key);
    })

    jdDetails.location.forEach(jt => {
      if (jt.isMandatory && Array.isArray(jdKeys.mandatory_locations)) jdKeys.mandatory_locations.push(jt.key);
      else if (Array.isArray(jdKeys.locations)) jdKeys.locations.push(jt.key);
    })

    jdDetails.skills.forEach(jt => {
      if (jt.isMandatory && Array.isArray(jdKeys.mandatory_skills)) jdKeys.mandatory_skills.push(jt.key);
      else if (Array.isArray(jdKeys.skills)) jdKeys.skills.push(jt.key);
    })

    jdKeys.industries = jdDetails.industries;
    jdKeys.schools = jdDetails.school;
    jdKeys.degrees = jdDetails.degree;
    jdKeys.education_majors = jdDetails.fieldofstudy;
    jdKeys.fromYrsOfExperience = jdDetails.fromYrsOfExperience;
    jdKeys.toYrsOfExperience = jdDetails.toYrsOfExperience;


    // scDetails.jobcompanyname.forEach(el => {
    //   if (el.isMandatory && Array.isArray(jdKeys.mandatory_companies)) jdKeys.mandatory_companies.push(el.key);
    //   else if (Array.isArray(jdKeys.companies)) jdKeys.companies.push(el.key);
    // });

    // scDetails.jobindustryname.forEach(el => {
    //   if (el.isMandatory && Array.isArray(jdKeys.mandatory_industries)) jdKeys.mandatory_industries.push(el.key);
    //   else if (Array.isArray(jdKeys.industries)) jdKeys.industries.push(el.key);
    // });

    // scDetails.schools.forEach(el => {
    //   if (el.isMandatory && Array.isArray(jdKeys.mandatory_schools)) jdKeys.mandatory_schools.push(el.key);
    //   else if (Array.isArray(jdKeys.schools)) jdKeys.schools.push(el.key);
    // });

    // scDetails.currentlocation.forEach(el => {
    //   if (el.isMandatory && Array.isArray(jdKeys.mandatory_locations)) jdKeys.mandatory_locations.push(el.key);
    //   else if (Array.isArray(jdKeys.locations)) jdKeys.locations.push(el.key);
    // });

    // scDetails.skills.forEach(el => {
    //   if (el.isMandatory && Array.isArray(jdKeys.mandatory_skills)) jdKeys.mandatory_skills.push(el.key);
    //   else if (Array.isArray(jdKeys.skills)) jdKeys.skills.push(el.key);
    // });

    // scDetails.degrees.forEach(el => {
    //   if (el.isMandatory && Array.isArray(jdKeys.mandatory_degrees)) jdKeys.mandatory_degrees.push(el.key);
    //   else if (Array.isArray(jdKeys.degrees)) jdKeys.degrees.push(el.key);
    // });

    // scDetails.fieldOfStudy.forEach(el => {
    //   if (el.isMandatory && Array.isArray(jdKeys.mandatory_education_majors)) jdKeys.mandatory_education_majors.push(el.key);
    //   else if (Array.isArray(jdKeys.education_majors)) jdKeys.education_majors.push(el.key);
    // });

    // scDetails.companysize.forEach(el => {
    //   if (el.isMandatory && Array.isArray(jdKeys.mandatory_company_sizes)) jdKeys.mandatory_company_sizes.push(el.key);
    //   else if (Array.isArray(jdKeys.company_sizes)) jdKeys.company_sizes.push(el.key);
    // });

    // jdKeys.fromYrsOfExperience = scDetails.fromYrsOfExperience;
    // jdKeys.toYrsOfExperience = scDetails.toYrsOfExperinece;

    return jdKeys;
  }

  getMandoryJDData() {

  }

  private filterAndSCFormat(list: Array<string>, isMandatory = false) {
    return list.filter(Boolean).map(el => ({ key: el, isMandatory }));
  }

  private isValidLocation(resp: FreemiumJdData): boolean {
    const continent = resp?.jdData?.Location?.continent;
    const country = resp?.jdData?.Location?.country;

    if (!continent || !country)
      return false;

    return this.VALID_CONTINENTS.includes(continent.trim().toLowerCase());
  }

  private getLocation(jdResp: FreemiumJdData) {
    let response = "";

    const location = jdResp?.jdData?.Location;

    const city = location?.city?.toString().trim();
    const state = location?.state?.toString().trim();
    const country = location?.country?.toString().trim();

    if (city?.length)
      response = city;

    if (state?.length) {
      if (response.length) response = response + `, ${state}`;
      else response = state;
    }

    if (response.length)
      response = response + `, ${country}`;
    else
      response = country;

    return {
      location: response,
      continent: location?.continent ? location.continent : null
    };
  }

  private getUniqueSkills(jdData: FreemiumJdData): Array<string> {
    let skills = [];

    if (Array.isArray(jdData.jdData['Preferred Skills']))
      skills = skills.concat(jdData.jdData['Preferred Skills']);
    if (Array.isArray(jdData.jdData.Tools))
      skills = skills.concat(jdData.jdData.Tools);
    if (Array.isArray(jdData.jdData['Mandatory Skills']))
      skills = skills.concat(jdData.jdData['Mandatory Skills']);

    skills = skills.map(el => el.toLowerCase());

    return _.uniq(skills);
  }

  getDataReadyForJD(jdDetails: FreemiumJdData) {
    const jdDataReady = new mandatoryFreemiumJDKeys();
    const jdData = jdDetails.jdData;
    if (jdData['Job Title'])
      jdDataReady.jobtitle.push({ key: jdData['Job Title'], isMandatory: false });

    if (jdData['Suggested job Title'] && Array.isArray(jdData['Suggested job Title'])) {
      const suggestedJobTitles = this.filterAndSCFormat(jdData['Suggested job Title'], false);
      jdDataReady.jobtitle = jdDataReady.jobtitle.concat(suggestedJobTitles);
    }

    if (jdData['Target Company'])
      jdDataReady.company = this.filterAndSCFormat(jdData['Target Company']);

    if (jdData.Industry)
      jdDataReady.industries = (jdData.Industry);

    if (jdData.School)
      jdDataReady.school = (jdData.School)

    if (this.isValidLocation(jdDetails)) {
      const { location, continent } = this.getLocation(jdDetails);
      jdDataReady.location = this.filterAndSCFormat([location]);
      jdDataReady.locationcontinent = continent;
      // response.locationcontinent = continent;
    }

    const uniqueSkills = this.getUniqueSkills(jdDetails);
    if (uniqueSkills.length)
      jdDataReady.skills = this.filterAndSCFormat(uniqueSkills);

    if (jdData.Degree)
      jdDataReady.degree = (jdData.Degree);



    if (jdData['Field of study'])
      jdDataReady.fieldofstudy = (jdData['Field of study']);

    if (jdData['Years of experience'] && jdData['Years of experience']['maximum experience'])
      jdDataReady.toYrsOfExperience = jdData['Years of experience']['maximum experience'];

    if (jdData['Years of experience'] && jdData['Years of experience']['minimum experience'])
      jdDataReady.fromYrsOfExperience = jdData['Years of experience']['minimum experience'];

    return jdDataReady;
  }

  getPersonSearchRecommendForFreemium() {
    const request = this.getRequestWithFilters();
    this.emitLoaderObject(LoaderType.LODER_TYPE.RECOMMENDED_CANDIDATE);

    this.freemiumApiService.getFreemiumRecommendData(request).subscribe(response => {
      const candidateObject = new PersonData();
      if (response.status == 'success') {
        candidateObject.candidateList = response?.data?.results?.length ? response.data.results.map(c => ({ ...c, selected: false })) : [];
        candidateObject.totalCandidatesCount = response.data?.totalresultscount;
        candidateObject.talentdiscoveryhistoryid = response?.data?.talentdiscoveryhistoryid;
        candidateObject.totalresultscount = response?.data?.totalresultscount;
        candidateObject.booleanquery = response?.data?.booleanquery;
      }
      this.emitFreemiumRecCandidateObject(candidateObject);
      this.getStatsAggs();
    })
  }

  private recCandidateDataSubject: Subject<PersonData> = new Subject();


  emitFreemiumRecCandidateObject(recCandidateData: PersonData) {
    this.recCandidateDataSubject.next(recCandidateData);
  }

  get recFreemiunCandidateDataEvent(): Observable<PersonData> {
    return this.recCandidateDataSubject.asObservable();
  }

  getStatsAggs() {
    this.emitLoaderObject(LoaderType.LODER_TYPE.STATS);
    forkJoin([
      this.getAggregationReport("total_tenure_median"),
      this.getAggregationReport("gender"),
      this.getAggregationReport("changedjobs")
    ]).subscribe(res => this.emitFreemiumStatsObject(res));
  }

  private freemiumStatsSubject: Subject<[any, any, any]> = new Subject();

  emitFreemiumStatsObject(statsObject: [any, any, any]) {
    this.freemiumStatsSubject.next(statsObject);
  }


  get statsFreemiumUpdateEvent(): Observable<[any, any, any]> {
    return this.freemiumStatsSubject.asObservable();
  }

  get fetchFilterChipsData(): FreemiumFilter {
    return Object.assign({}, this.freemiumFilters);
  }

  setFilterChipsData(filterData: FreemiumFilter) {
    this.freemiumFilters = Object.assign({}, filterData);

  }

  public static REDIRECT_SOURCES = {
    JOB_DESCRIPTION: "job-description",
    QUICK_SEARCH: "quick-search"
  }

  get fetchFilterModalData(): mandatoryFreemiumJDKeys {
    return Object.assign({}, this.freemiumModalData);
  }

  setFilterModalData(filterData: mandatoryFreemiumJDKeys) {
    this.freemiumModalData = Object.assign({}, filterData);

  }

  resetFreemium() {
    this.freemiumParams.continentstobeincluded = [];
    this.freemiumParams.jobTitleSelectedList = [];
    this.freemiumParams.skillsSelectedList = [];
    this.freemiumParams.locationSelectedList = [];
    this.freemiumParams.job_description_keys = {};
  }

  public static invalid_workemail_domain_list = [
    "hotmail",
    "gmail",
    "yahoo",
    "outlook",
    "rediff",
    "xyz",
    "qq",
    "test",
    "rediffmail",
    "icloud",
    "ymail",
    "me",
    "live",
    "aol"
  ]

  get showInsightsTab(): Observable<any> {
    return this.showInsightsAfterLoader.asObservable();
  }

  changeInsightsAfterLoader(statsObject) {
    this.showInsightsAfterLoader.next(statsObject);
  }

  private loaderSubject: Subject<LoaderType> = new Subject();

  get loaderEvent(): Observable<LoaderType> {
    return this.loaderSubject.asObservable();
  }

  emitLoaderObject(loaderObject: LoaderType) {
    this.loaderSubject.next(loaderObject);
  }

}
